import { appBorders, appColors, SIDEBAR_COLLAPSED_WIDTH } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerPathDiagram } from '@backrs_ui/grow-ui/src/components/CareerPathDiagram/CareerPathDiagram';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const DIALOG_STRINGS = appStrings.modules.start.careerTrackDialog;

export const CareerTrackPage = () => {
  return (
    <Box sx={containerStyle}>
      <Box sx={contentContainerStyle}>
        <Box sx={textAndDiagramContainerStyle}>
          <Box sx={textContainerStyle}>
            <Typography variant="h4" sx={headerTextStyle}>
              {DIALOG_STRINGS.title}
            </Typography>
            {DIALOG_STRINGS.content.map((text, index) => (
              <Typography key={index} variant="body1" sx={bodyTextStyle}>
                {text}
              </Typography>
            ))}
          </Box>

          <Box sx={diagramContainerStyle}>
            <CareerPathDiagram
              minimumTrack="Semi-skilled"
              entrepreneurshipRecommended={true}
              popoverPosition="20vh"
            />
            <Box sx={arrowAndBottomTextContainerStyle}>
              <Typography variant="body1" sx={arrowTextTopStyle}>
                {DIALOG_STRINGS.bottomContentTop}
              </Typography>
              <Box
                component="img"
                src="/images/gradient-arrow.svg"
                alt="Blueprint Logo"
                width={'100%'}
              />
              <Typography variant="body1" sx={arrowTextBottomStyle}>
                {DIALOG_STRINGS.bottomContentBottom}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const arrowTextTopStyle: SxProps<Theme> = {
  position: { sm: 'absolute' },
  bottom: '28px',
  fontSize: '14px',
} as const;

const arrowTextBottomStyle: SxProps<Theme> = {
  position: { sm: 'absolute' },
  top: '22px',
  fontSize: '14px',
} as const;

const containerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flexGrow: 1,
  minHeight: '100svh',
  py: {
    xs: 3,
    sm: 2,
    md: 2,
  },
  px: {
    xs: 3,
    sm: 4,
  },
  boxSizing: 'border-box',
  maxHeight: '100svh',
  ml: `${SIDEBAR_COLLAPSED_WIDTH}px`,
} as const;

const arrowAndBottomTextContainerStyle: SxProps<Theme> = {
  ps: 5,
  borderRadius: 4,
  position: { sm: 'relative' },
} as const;

const contentContainerStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  border: appBorders.backrsBorders.black,
  boxShadow: appBorders.backrsDropShadowBorders.black.boxShadow,
  borderRadius: 4,
  maxWidth: '100%',
  boxSizing: 'border-box',
  alignSelf: 'center',
  justifySelf: 'center',
  overflowY: 'auto',
} as const;

const textAndDiagramContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    sm: 'column',
    md: 'column',
    lg: 'row',
  },
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: 4,
} as const;

const textContainerStyle: SxProps<Theme> = {
  width: { xs: '100%', xl: '50%' },
  pr: { sm: 12 },
} as const;

const headerTextStyle: SxProps<Theme> = {
  fontWeight: 700,
  mb: 4,
  '@media (max-width: 768px)': {
    fontSize: '15pt',
    mb: 2,
  },
} as const;

const diagramContainerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  justifySelf: 'flex-end',
  flexDirection: 'column',
  gap: 4,
} as const;

const bodyTextStyle: SxProps<Theme> = {
  mb: 4,
  maxWidth: '500px',
  lineHeight: 1.3,
} as const;
